export class SigningModel {
    public Url: string;
    public SignersNumber: number;
    public PackageId: string;
}
